import AdjustIcon from '@mui/icons-material/Adjust';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { motion } from "framer-motion";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAddToCartMutation, useAddToGuestUserCartMutation } from '../../../redux/APIs/cartApi';
import { useGetProductDetailsQuery, useLazyGetCourierDeliveryExpectedTimeQuery, useLazyGetCourierServiceabilityQuery } from '../../../redux/APIs/productApi';
import { selectUser } from '../../../redux/Slices/userSlice';
import useAuth from '../../../utils/Hooks/useAuth';
import { useToast } from '../../../utils/ToastManager';
import './ProductDetails';
import CheckPincode from './pincode/PincodeCheck';
import ProductSections from './product sections/ProductSections';

const ProductDetails = () => {
  const isLoggedIn = useAuth();
  const user = useSelector(selectUser);
  console.log('user', user)
  console.log('isLoggedIn', isLoggedIn)
const [scrollNav, setScrollNav] = useState('about');
const [isHovered, setIsHovered] = useState(false);
const [hoveredUser, setHoveredUser] = useState(null);
const [pinCode, setPinCode] = useState('');
const addToast = useToast();
  const {slug} = useParams();
  console.log('Params', slug);
  const {data: productDetails} = useGetProductDetailsQuery(slug);

  console.log('productDetails', productDetails?.product?._id)

  const [addTologgedinCart] = useAddToCartMutation();
  const [addToGuestUserCart] = useAddToGuestUserCartMutation();
  const [getCourierServiceability] = useLazyGetCourierServiceabilityQuery();
  const [getCourierDeliveryTime, { data: deliveryTimeData, error, isLoading }] = useLazyGetCourierDeliveryExpectedTimeQuery();

console.log('Checked data', deliveryTimeData);
  const handleAddToCart = async (productId, quantity) => {
    try {
      // Check if the user is logged in and the user object exists
      console.log({isLoggedIn})
      if (isLoggedIn) {
        // Call the API for logged-in users
        const response = await addTologgedinCart({
          cartItems: [
            {
              product: productId,
              quantity,
            },
          ],
        });
        console.log('Cart updated for logged-in user:', response);
      } else {
        // Call the API for guest users
        const response = await addToGuestUserCart({
          cartItems: [
            {
              product: productId,
              quantity,
            },
          ],
        });
        console.log('Cart updated for guest user:', response);
      }
    } catch (error) {
      console.error('Failed to add to cart:', error);
    }
  };
  
  // const handleCourierServiceability = async() => {
  //   await getCourierServiceability()
  // }
  
  
  const handlePinChange = (e) => {
    const inputValue = e.target.value;

    // Allow only if the length is exactly 6 or empty for reset
    if (inputValue === '' || /^[0-9]{0,6}$/.test(inputValue)) {
      setPinCode(inputValue);
    }
  };

  const handleBlur = () => {
    // Validate if it's exactly 6 digits
    if (pinCode.length !== 6) {
      setPinCode(''); 
    }
  };

  const handleCheckPincode = async() => {
    if(pinCode.length === 6){
      const res = await getCourierDeliveryTime(pinCode);
      console.log('res', res);
    }
  }


  gsap.registerPlugin(ScrollTrigger);


  const buttonVariants = {
    initial: { opacity: 0, scale: 0.5 },
    animate: { opacity: 1, scale: 1}
  }


  const buttonStyleVariants = {
    initial: { opacity: 0.5, scale: 1 },
    animate: { opacity: 1, scale: 1.1 },
  };
  
  const buttonHighlightVariants = {
    initial: { width: "100%", opacity: 0 },
    active: { width: "100%", opacity: 1, backgroundColor: "#e0218a" },
  };
  
  const textVariants = {
    initial: { x: -20, opacity: 0 },
    animate: { x: 0, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
  };

const borderVariants = {
  initial: {
    borderRadius: '50%',
    borderWidth: '0px',
    borderColor: '#e0218a',
    borderStyle: 'solid',
  },
  hover: {
    borderWidth: '2px',
    transition: {
      duration: 1,
      repeat: Infinity,
      repeatType: 'loop',
    }
  }
};



const handleToastButtonClick = () => {
  console.log('Toast button clicked');
  // Implement action on button click
};

const showToast = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 768) {
    // For mobile and tablet screens
    addToast('Item added to cart!', 'success', 'bottomCenter', '#14183d', 'GO TO CART', handleToastButtonClick);
  } else {
    // For laptop and larger screens
    addToast('Item added to cart!', 'success', 'topRight', '#14183d', 'GO TO CART', handleToastButtonClick);
  }
};


const toggleScrollNav = (val) => {
  setScrollNav(val)
}



  gsap.to('.left-nav', {
    scrollTrigger: {
      trigger: '.product-details', // the element that triggers the animation
      start: '+=580px', // when the top of the trigger hits the top of the viewport
      end: '+=600px', // the distance over which the animation occurs
      toggleActions: 'play none none reverse', // onEnter, onLeave, onEnterBack, onLeaveBack
      // markers: true, // this adds visual markers for debugging
      scrub: true, // smooth scrubbing
    },
    opacity: 0,
    duration: 1,
    ease: 'power2.inOut',
  });

  gsap.to('.how-it-made', {
    scrollTrigger: {
      trigger: '.product-details', // the element that triggers the animation
      start: '+=300px', // when the top of the trigger hits the top of the viewport
      end: '+=600px', // the distance over which the animation occurs
      toggleActions: 'play none none reverse', // onEnter, onLeave, onEnterBack, onLeaveBack
      // markers: true, // this adds visual markers for debugging
      scrub: true, // smooth scrubbing
    },
    backgroundColor: 'blue',
    duration: 1,
    ease: 'power2.inOut',
  });


  const items = [
    { name: "about", label: "About Art" },
    { name: "details", label: "Art Details" },
    { name: "reviews", label: "Reviews" },
    { name: "history", label: "History" },
  ];

  const users = [
    {
      id: 1,
      name: 'Claudia Alves',
      profileImage: 'https://randomuser.me/api/portraits/women/68.jpg',
      rating: '★★★★★',
    },
    {
      id: 2,
      name: 'John Doe',
      profileImage: 'https://randomuser.me/api/portraits/men/75.jpg',
      rating: '★★★★☆',
    },
    {
      id: 3,
      name: 'Emily Smith',
      profileImage: 'https://randomuser.me/api/portraits/women/32.jpg',
      rating: '★★★★★',
    },
    {
      id: 4,
      name: 'Michael Brown',
      profileImage: 'https://randomuser.me/api/portraits/men/34.jpg',
      rating: '★★★★☆',
    },
    {
      id: 5,
      name: 'Sarah Johnson',
      profileImage: 'https://randomuser.me/api/portraits/women/27.jpg',
      rating: '★★★★★',
    },
    {
      id: 6,
      name: 'Chris Lee',
      profileImage: 'https://randomuser.me/api/portraits/men/12.jpg',
      rating: '★★★☆☆',
    },
    {
      id: 7,
      name: 'Anna Wilson',
      profileImage: 'https://randomuser.me/api/portraits/women/85.jpg',
      rating: '★★★★☆',
    },
    {
      id: 8,
      name: 'David Martinez',
      profileImage: 'https://randomuser.me/api/portraits/men/45.jpg',
      rating: '★★★★★',
    },
    {
      id: 9,
      name: 'Sophia Taylor',
      profileImage: 'https://randomuser.me/api/portraits/women/55.jpg',
      rating: '★★★★☆',
    },
    {
      id: 10,
      name: 'James Anderson',
      profileImage: 'https://randomuser.me/api/portraits/men/10.jpg',
      rating: '★★★☆☆',
    },
  ];

  const sectionVariants = {
    hidden: { opacity: 0, x: 100 }, // Start from the right side and invisible
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } }, // Move to original position and fade in
  };

  
  
  

  return (
    <div className="max-sm:relative w-full flex bg-white sm:mt-[70px] max-sm:mt-[40px]">
      <div className="flex flex-col mt-32 items-start gap-2 max-sm:absolute max-sm:left-0 max-sm:px-1 max-sm:py-4 max-sm:bg-white max-sm:shadow-xl rounded-r-3xl">
        {items.map((item) => (
          <motion.button
            key={item.name}
            className="flex items-center relative transition-colors duration-300 sm:w-[180px] group sm:pl-8"
            onClick={() => toggleScrollNav(item.name)}
          >
            {/* Dot and Icon in the same position */}
            <div className="relative w-6 h-7 flex justify-center items-center">
              <motion.div
                initial={{ opacity: 0, scale: 0 }}
                animate={
                  scrollNav === item.name
                    ? { opacity: 1, scale: 1 }
                    : { opacity: 0, scale: 0 }
                }
                transition={{ duration: 0.5 }}
                className="absolute"
              >
                <AdjustIcon className="text-pink-600" />
              </motion.div>

              <div className="w-2 h-2">
                <motion.div
                  initial={{ opacity: 1, scale: 1 }}
                  animate={
                    scrollNav === item.name
                      ? { opacity: 0, scale: 0 }
                      : { opacity: 1, scale: 1 }
                  }
                  transition={{ duration: 0.5 }}
                  className={`absolute w-2 h-2 rounded-full bg-slate-400 transition-opacity duration-300 ${
                    scrollNav === item.name ? 'opacity-0' : 'opacity-100'
                  }`}
                ></motion.div>
              </div>
            </div>

            {/* Hover Text */}
            <motion.span
              initial={
                scrollNav === item.name
                  ? { opacity: 1, x: 0 }
                  : { opacity: 0, x: -10 }
              }
              animate={scrollNav === item.name ? { opacity: 1, x: 0 } : {}}
              whileHover={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className={`whitespace-nowrap text-sm text-pink-600 group-hover:inline-block bg-white pl-3 py-[1px] ${
                scrollNav === item.name ? 'block' : 'hidden'
              }`}
              style={{
                display: window.innerWidth < 640 ? 'none' : 'inline-block', // Manually hide below 640px (sm)
              }}
            >
              {item.label}

              {/* Sliding border effect */}
              {scrollNav === item.name && (
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: '100%' }}
                  transition={{ duration: 0.5 }}
                  className="border-b-[1.5px] border-pink-600 mt-[1px]"
                />
              )}
            </motion.span>
          </motion.button>
        ))}
      </div>

      <div className="max-lg:ml-0 flex-1 overflow-y-auto">
        <section className="w-full max-lg:h-full p-10 max-lg:p-5  pt-0 flex max-lg:flex-col justify-center xl:gap-6">
        <div className="flex w-96 max-lg:w-full justify-center max-lg:mt-8 rounded-md rounded-b-2xl">
  <img
    src="https://www.vanivrtti.com/cdn/shop/files/DSC00996.jpg?v=1709635315&width=1400"
    className="object-cover object-top w-full h-full max-sm:h-full"
  />
</div>

          <div className="flex-1 custom-cursor text-sm mt-8 flex gap-8">
            <div className="flex-1">
              <div className="xl:pb-6">
                <p className="text-xl max-sm:text-lg">
                  Gopalpur Tussar Silk Temple Kumbha Saree
                  {/* {productDetails?.product?.name} */}
                </p>
                <div className="flex gap-3 items-end">
                  <span className="text-2xl max-sm:text-xl font-[600] ">
                    ₹7500
                    {/* {productDetails?.product?.price} */}
                  </span>
                  <span className="text-lg line-through text-zinc-400 font-[300]">
                    ₹8999
                    {/* {productDetails?.product?.markedPrice} */}
                  </span>
                  <br />
                </div>
                <p className="text-zinc-400 text-[0.8rem]">
                  Inclusive of all taxes
                </p>
              </div>
              <div className="w-full max-xl:block pb-8 hidden mt-6 max-md:text-center">
                <div className="flex gap-2 w-full">
                  <button className="w-12 h-12 rounded-full bottom-0 p-1 max-sm:flex justify-center items-center text-xs hidden border-[1px] border-gray-400">
                    <FavoriteBorderRoundedIcon style={{ fontSize: 'large' }} />
                  </button>
                  <button
                    className="h-12 xl:w-72 flex-1 border-2 rounded-full bg-gradient-to-r from-pink-400 to-pink-700 hover:border-yellow-500 text-white hover:font-semibold transition-all"
                    onClick={() =>
                      handleAddToCart(productDetails?.product?._id, 1)
                    }
                  >
                    ADD TO CART
                  </button>
                </div>
                <div className="mt-2 flex gap-1 text-sm max-xl:w-72 max-md:w-full max-sm:hidden">
                  <motion.div
                    className="w-12 h-12 rounded-full bg-white flex justify-center items-center relative overflow-hidden border-[1px] hover:border-pink-700 hover:text-pink-700 hover:border gap-1 "
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    initial={{ width: '3rem' }}
                    whileHover={{ width: '8rem' }}
                  >
                    <FavoriteBorderRoundedIcon style={{ fontSize: 'large' }} />
                    {isHovered && (
                      <motion.div
                        className="bottom-0 rounded-md p-1 flex justify-center items-center text-xs"
                        initial={{ opacity: 1 }}
                        animate={{ opacity: isHovered ? 1 : 0 }}
                        transition={{ duration: 0.2 }}
                      >
                        WISHLIST
                      </motion.div>
                    )}
                  </motion.div>
                  <button className="h-12 flex-1 bg-pink-50 rounded-full flex items-center justify-center relative group hover:text-pink-700 hover:border-pink-500 hover:border transition-[0.5]">
                    <ShareOutlinedIcon style={{ fontSize: 'large' }} />
                    <span className="ml-3 text-center text-xs">Share</span>
                  </button>
                </div>
              </div>
              {/* <div className="sm:mt-10">
                <div
                  className={`flex gap-2 w-52 border-[1px] ${
                    pinCode?.length === 6
                      ? 'border-pink-600 transition-all'
                      : 'border-zinc-400 transition-all'
                  }  rounded-full h-10 py-2 px-3`}
                >
                  <input
                    type="number"
                    maxLength={6}
                    onWheel={(e) => e.target.blur()}
                    className="h-full w-full border-none outline-none no-spinner"
                    value={pinCode}
                    onChange={handlePinChange}
                    onBlur={handleBlur}
                  />
                  <button
                    className={`text-[0.75rem] transition-all ${
                      pinCode?.length === 6 &&
                      'text-pink-600 font-[600] transition-all'
                    }`}
                    onClick={handleCheckPincode}
                  >
                    CHECK
                  </button>
                </div>
                {pinCode?.length !== 6 && pinCode?.length > 0 && (
                  <div className="text-xs transition-all text-red-500 mt-1 ml-5">
                    Please enter exactly 6 digits
                  </div>
                )}
                {!deliveryTimeData?.success && <div className="flex gap-3 items-center mb-4 mt-4 hover">
                  <span className="hover:-rotate-12 hover:scale-125 transition-all bg-gradient-button p-2 rounded-full">
                    <LocalShippingOutlinedIcon
                      style={{ fontSize: '1.4rem', color: 'white' }}
                    />
                  </span>
                  <span>Usually Dispatches within 1 to 2 Days</span>
                </div>}
                {!deliveryTimeData?.success && <div className="flex gap-3 items-center mb-4">
                  <span className="hover:scale-125 transition-all bg-gradient-button p-2 rounded-full">
                    <FmdGoodOutlinedIcon
                      style={{ fontSize: '1.4rem', color: 'white' }}
                    />
                  </span>
                  <span>Enter pincode for delivery date</span>
                </div>}
                {deliveryTimeData?.success && <div className="flex gap-3 items-center mb-4 mt-4 hover">
                  <span className="hover:-rotate-12 hover:scale-125 transition-all bg-gradient-button p-2 rounded-full">
                    <LocalShippingOutlinedIcon
                      style={{ fontSize: '1.4rem', color: 'white' }}
                    />
                  </span>
                  <span>Expected Delivery by {deliveryTimeData.estimated_delivery_date}</span>
                </div>}
                <div className="flex gap-3 items-center mb-4">
                  <span className="hover:rotate-180 hover:scale-125 transition-all bg-gradient-button p-2 rounded-full">
                    <AutorenewRoundedIcon
                      style={{ fontSize: '1.4rem', color: 'white' }}
                    />
                  </span>
                  <span>Easy 7 day return</span>
                </div>
              </div> */}
              <CheckPincode/>
            </div>
            <div className="px-6 w-72 hidden xl:block">
              <button
                className="h-12 w-full border-2 rounded-full bg-gradient-button hover:border-yellow-500 text-white hover:font-semibold transition-all"
                onClick={() =>
                  handleAddToCart(productDetails?.product?._id, 1)
                }
              >
                ADD TO CART
              </button>
              <div className="mt-2 flex gap-1 text-sm ">
                <motion.div
                  className="w-12 h-12 rounded-full bg-white flex justify-center items-center relative overflow-hidden border-[1px] hover:border-pink-700 hover:text-pink-700 hover:border hover:font-[600] gap-1 "
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  initial={{ width: '3rem' }}
                  whileHover={{ width: '8rem' }}
                >
                  <FavoriteBorderRoundedIcon style={{ fontSize: 'large' }} />
                  {isHovered && (
                    <motion.div
                      className="bottom-0 rounded-md p-1 flex justify-center items-center text-xs"
                      initial={{ opacity: 1 }}
                      animate={{ opacity: isHovered ? 1 : 0 }}
                      transition={{ duration: 0.2 }}
                    >
                      WISHLIST
                    </motion.div>
                  )}
                </motion.div>
                <button className="h-12 flex-1 bg-pink-50 rounded-full flex items-center justify-center relative group hover:text-pink-700 hover:border-pink-500 hover:border hover:font-[600] transition-[0.5]">
                  <ShareOutlinedIcon style={{ fontSize: 'large' }} />
                  <span className="ml-3 text-center text-sm">Share</span>
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="w-full h-fit mt-8 px-6 relative">
          <div className="flex justify-between">
            <div className="flex gap-4 ">
              <div className="w-20 h-20 rounded-full bg-slate-300"></div>
              <div className="w-[260px]">
                <span className="text-base font-[600]">
                  The Fabric Behind It
                </span>
                <div className="text-sm text-zinc-500 text-[400] mt-1">
                  Made using pure cotton, this fabric is gentle on your skin and
                  naturally breathable. A perfect blend of tradition and
                  comfort.
                </div>
              </div>
            </div>
            <div className="flex gap-4 ">
              <div className="w-20 h-20 rounded-full bg-slate-300"></div>
              <div className="w-[260px]">
                <span className="text-base font-[600]">Crafted Pattern</span>
                <div className="text-sm text-zinc-500 text-[400] mt-1">
                  Animal Pattern. These designs capture the wild spirit of
                  nature's creatures, adding boldness to your style.
                </div>
              </div>
            </div>
            <div className="flex gap-4 ">
              <div className="w-20 h-20 rounded-full bg-slate-300"></div>
              <div className="w-[260px]">
                <span className="text-base font-[600]">
                  The Fabric Behind It
                </span>
                <div className="text-sm text-zinc-500 text-[400] mt-1">
                  Made using pure cotton, this fabric is gentle on your skin and
                  naturally breathable. A perfect blend of tradition and
                  comfort.
                </div>
              </div>
            </div>
          </div>
          
        </section> */}
        {/* <HorizontalScrollFeed/> */}
        <ProductSections/>
        {/* <section className="w-full h-fit bg-white">
          <div className="relative h-fit pb-4">
            <p className="text-left text-xl font-[600]">
              In Their Own Words: The Handloom Experience
            </p>
            <div className="w-32 h-20 absolute left-0 bg-gradient-to-r from-white to-transparent"></div>
            <div className="w-32 h-20 absolute right-0 bg-gradient-to-l from-white to-transparent"></div>
            <div className="flex items-center gap-4 w-full overflow-x-scroll no-scrollbar py-2">
              {users.map((user) => (
                <div
                  key={user.id}
                  className="flex gap-1 pl-1 pr-3 py-1 border bg-white shadow-md rounded-full w-fit"
                >
                  <div className="w-9 h-9 rounded-full overflow-hidden">
                    <img
                      src={user.profileImage}
                      alt={user.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="text-left">
                    <div className="font-semibold text-xs text-gray-800 whitespace-nowrap">
                      {user.name}
                    </div>
                    <div className="text-pink-300 text-xs">{user.rating}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* <div className='w-full h-fit py-12 '>
            <CustomerReviewCard/>
          </div> */}
        {/* </section> */}

        {/* <section className="w-full h-[800px] bg-teal-600 bg-opacity-10 how-it-made">
          <HowItmade />
        </section> */}
        {/* <section className="w-full h-[600px] bg-white"></section> */}
        {/* <div className="h-[600px] bg-gray-600 w-full"></div> */}
      </div>
    </div>
  );
}

export default ProductDetails